import Pica from 'pica';

const pica = Pica({
	features: ['js', 'wasm', 'cib', 'ww'],
});

export async function resize(input: File, size: { width: number; height: number } = { width: 256, height: 256 }): Promise<File> {
	if (input === null) throw new Error('Input cannot be null');

	const { width, height } = size;

	const from = document.createElement('canvas');

	const image = await createImageAsync(URL.createObjectURL(input));

	if (image.width <= width && image.height <= height) {
		//No need to resize if it's smaller
		return input;
	}
	const start = performance.now();
	from.width = image.width;
	from.height = image.height;

	const ctx = from.getContext('2d');
	ctx?.drawImage(image, 0, 0);

	const scale_factor = Math.min(width / image.width, height / image.height);

	const newWidth = image.width * scale_factor;
	const newHeight = image.height * scale_factor;

	const to = document.createElement('canvas');
	to.width = newWidth;
	to.height = newHeight;

	await pica.resize(from, to);

	console.log(`Resizing took: ${((performance.now() - start) / 1000).toFixed(2)} Seconds`);
	const out = new File([await asyncToBlob(to, input.type)], input.name, { type: input.type });
	return out;
}

function asyncToBlob(canvas: HTMLCanvasElement, type: string): Promise<Blob> {
	return new Promise((resolve, reject) => {
		canvas.toBlob((blob) => {
			if (blob === null) return reject('invalid blob');
			resolve(blob);
		}, type);
	});
}

function createImageAsync(src: string): Promise<HTMLImageElement> {
	return new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = () => resolve(img);
		img.onerror = reject;
		img.src = src;
	});
}
